/**
 * A blood test: a blood-only package, or any other product that is a blood
 * draw. Radiation and contrast agent are imaging attributes and are never shown
 * on these (AHD-13466).
 *
 * Packages are judged on `package_types`, as PackageCard does: Advanced and Pro
 * include a blood draw but are MRI packages. For every other product
 * `package_types` lists the packages it can be added to (blood add-ons say
 * both), so `includes_blood_draw` decides.
 */
export function isBloodTestProduct(product: {
  product_type?: string;
  package_types?: string[];
  includes_blood_draw?: boolean;
}): boolean {
  if (product.product_type === "package") {
    return product.package_types?.includes("blood-only") ?? false;
  }
  return product.includes_blood_draw === true;
}

/** Information rows that describe imaging; never shown on a blood test. */
const IMAGING_INFO_LABELS = new Set([
  "addonDialog.info.radiation",
  "addonDialog.info.contrastDye",
  "packageDialog.info.radiation",
  "packageDialog.info.contrastDye",
]);

export const isImagingInfoRow = (row: { labelKey: string }): boolean =>
  IMAGING_INFO_LABELS.has(row.labelKey);
